import React, { render, Component } from 'preact';
export default class GDPR extends Component {
    constructor(props) {
        super(props)
        this.state = { display: "static" };

        if (localStorage.getItem("cookie") !== null) {
            if (localStorage.getItem("cookie") == 1) {
                this.state.display = "none";
            }
        }
    }

    hideCookie(){
        localStorage.setItem("cookie",1);
        this.setState({ display: "none" });
    }

    render() {
        return (
            <div id="accept-cookies-holder" style={{ display: this.state.display }}>
                <span>We use cookies to help enhance the experience on the website</span>
                <button onClick={() => { this.hideCookie(); }} id="accept-cookies-holder-button">Accept</button>
            </div>)
    }



}